module.exports = __webpack_public_path__ + "img/pen.38d73cd7.png";